import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
const Lesson = ({ lessonId,lesson, changeId, lessonsIds }) => {
    const {groupId, type} = useParams()


    const navigate = useNavigate()

    
    if (lesson) {
        const handleEdit = () => navigate(`/${type}/${groupId}/lessons/${lessonId}`)
        const handleShow = () => navigate(`/${type}/${groupId}/lessons/show/${lessonId}`)

      
        const cellStatus = lesson.active ? '' : 'table__cell--inactive'

        return (
            <tr className="table__row lesson">
                <td className={`table__cell ${cellStatus}`}>


<label className="inline-flex items-center space-x-2 cursor-pointer">
  <input 
    type="checkbox"
    className="h-5 w-5 text-blue-600 accent-blue-600 rounded border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
    checked={lessonsIds.includes(lessonId)}
    id={`lessonId-${lessonId}`}
    onChange={() => changeId(lessonId)}
    disabled={lesson.report}
  />
  <span className="text-xl text-gray-700 pr-2">  {lesson.group?.name}</span>
</label>

                    
                 

                  
                   
                </td>
                <td className={`table__cell ${cellStatus}`}>
                    {lesson.title} 
                   
                </td>
                <td className={`table__cell ${cellStatus}`}>
                   {lesson.numberOfLessons}
                </td>
                <td className={`table__cell ${cellStatus}`}>
                    <span className="d-flex">
                    {lesson.dt.toString().slice(0,10)}
                    </span>
                    
                    </td>
                    <td className={`table__cell ${cellStatus}`}>
                        {lesson.report ? <span className='badge badge--report'>דווח</span> : <span className='badge badge--active'>לא דווח</span>}
                    </td>  
                <td className={`table__cell ${cellStatus}`}>
                    <div className='d-flex'>
                    <button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                    <button
                        className="icon-button table__button"
                        onClick={handleShow}
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </button>
                    </div>
                </td>
            </tr>
        )

    } else return null
}


export default Lesson